<template>
    <span
        :uk-tooltip="
            disabled
                ? 'title:' +
                  $t('x.module.disabled.hint', {x: $t('clickAndBuy')})
                : ''
        "
        :class="disabled ? 'module-disabled-struct' : ''">
        <span
            :class="
                disabled ? 'module-disabled uk-height-1-1' : 'uk-height-1-1'
            ">
            <ul uk-tab="animation: uk-animation-fade">
                <li v-for="tab in ['design', 'options', 'files']" :key="tab">
                    <a href="#">{{ $t(tab) }}</a>
                </li>
            </ul>
            <ul class="uk-switcher uk-margin">
                <li>
                    <div
                        class="uk-grid uk-grid-divider uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-1"
                        uk-grid>
                        <div>
                            <TextField
                                v-model="titleField.value"
                                :autocomplete="titleField.autocomplete"
                                :autofocus="titleField.autofocus"
                                :hasPasswordMeter="titleField.hasPasswordMeter"
                                :icon="titleField.icon"
                                :is-optional="titleField.optional"
                                :label="titleField.label"
                                :name="titleField.name"
                                :options="titleField.options"
                                :rules="titleField.rules"
                                :steps="titleField.steps"
                                :type="titleField.type"
                                :on-enter="actionDeclare"
                                :validate="validationTrigger"
                                @setValid="setValid" />

                            <div class="uk-margin-medium-top" />
                            <ClickAndBuyMediaForm
                                v-if="settings && settings.clickAndBuyInfos"
                                :id="id"
                                :data="newClickAndBuy.mediaFileId"
                                @file="setMediaFile"
                                :allowed-size="
                                    settings.clickAndBuyInfos.mediaFileSizeBytes
                                "
                                :allowed-extensions="
                                    settings.clickAndBuyInfos
                                        .mediaFileExtensions
                                "
                                :disabled="disabled" />

                            <div class="uk-margin-medium-top" />
                            <SwitchButton
                                :id="
                                    'clickandbuy-switch-active-' +
                                    this.clickAndBuy.id
                                "
                                v-model="isActive"
                                :label="$t('active')"
                                @input="success = false" />

                            <div class="uk-margin-medium-top" />
                            <SwitchButton
                                :id="
                                    'clickandbuy-switch-visible-' +
                                    this.clickAndBuy.id
                                "
                                v-model="isVisible"
                                :label="$t('listed')"
                                @input="success = false" />
                        </div>
                        <div>
                            <LabelWithError
                                is-optional
                                :label="$t('description')" />
                            <vue-editor
                                v-model="newClickAndBuy.text"
                                v-on:input="success = false" />

                            <div class="uk-margin-medium-top" />
                            <LabelWithError
                                is-optional
                                :label="$t('clickandbuy.email.text')" />

                            <div class="uk-text-small">
                                <Translate
                                    translation-key="placeholder.variable.email.description" />

                                <div
                                    class="uk-margin-small-top uk-margin-bottom uk-grid-small"
                                    uk-grid>
                                    <div
                                        v-for="placeholder in computedPlaceholders"
                                        :key="clickAndBuy.id + placeholder">
                                        <span
                                            v-on:click="
                                                fillPlaceholder(placeholder)
                                            ">
                                            <Button is-small mode="default">
                                                <Translate
                                                    :translation-key="
                                                        placeholder
                                                    "
                                                    prefix="{"
                                                    suffix="}" />
                                            </Button>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <vue-editor
                                ref="editoremail"
                                v-model="newClickAndBuy.emailText"
                                v-on:input="success = false" />
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="uk-grid uk-grid-divider uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-1"
                        uk-grid>
                        <div>
                            <SwitchButton
                                :id="
                                    'clickandbuy-switch-with-price-' +
                                    clickAndBuy.id
                                "
                                v-model="withPrice"
                                :label="$t('with.price')"
                                @input="success = false" />

                            <div v-if="withPrice">
                                <div class="uk-margin-small-bottom" />
                                <CurrencyInput
                                    v-model="priceField.value"
                                    :icon="priceField.icon"
                                    :label="computedPriceFieldLabel"
                                    :name="priceField.name"
                                    :options="computedCurrencyOptions"
                                    :rules="priceField.rules"
                                    :validate="trigger" />
                                <div class="uk-margin-small-bottom" />
                                <Translate
                                    class="child-description"
                                    translation-key="clickandbuy.min.price"
                                    :parameter="{
                                        x: getNumberWithCurrency(0.5),
                                    }" />

                                <div class="uk-margin-medium-top" />
                                <SwitchButton
                                    :id="
                                        'clickandbuy-switch-multiple-orderable-' +
                                        this.clickAndBuy.id
                                    "
                                    v-model="multipleOrderable"
                                    :label="$t('multipleOrderable')"
                                    @input="handleSwitchMultipleOrderable" />

                                <div v-if="!multipleOrderable">
                                    <SwitchButton
                                        class="uk-margin-medium-top"
                                        :id="
                                            'clickandbuy-switch-with-variable-price-' +
                                            this.clickAndBuy.id
                                        "
                                        v-model="withVariablePrice"
                                        :label="$t('variable.price')"
                                        @input="success = false" />
                                    <Translate
                                        class="child-description"
                                        translation-key="variable.price.description" />
                                </div>

                                <div class="uk-margin-medium-top" />
                                <SwitchButton
                                    :id="
                                        'clickandbuy-switch-with-shipping-fee-' +
                                        this.clickAndBuy.id
                                    "
                                    v-model="withShippingFee"
                                    :label="$t('with.shipping.fee')"
                                    @input="success = false" />

                                <div v-if="withShippingFee">
                                    <div class="uk-margin-small-bottom" />
                                    <CurrencyInput
                                        v-model="shippingFeeField.value"
                                        :icon="shippingFeeField.icon"
                                        :label="shippingFeeField.label"
                                        :name="shippingFeeField.name"
                                        :options="
                                            computedCurrencyOptionsShipping
                                        "
                                        :rules="shippingFeeField.rules"
                                        :validate="trigger" />

                                    <div v-if="multipleOrderable">
                                        <SwitchButton
                                            class="uk-margin-top"
                                            :id="
                                                'clickandbuy-switch-calc-shipping-once-' +
                                                this.clickAndBuy.id
                                            "
                                            v-model="shippingCostsOnce"
                                            :label="$t('shippingCostsOnce')"
                                            @input="success = false" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <LabelWithError
                                :label="
                                    $t('variants') + ' (' + $t('optional') + ')'
                                " />
                            <div class="uk-grid-small" uk-grid>
                                <div class="uk-width-expand">
                                    <select
                                        v-model="selectedVariant"
                                        id="variant-selector"
                                        v-on:change="success = null"
                                        :disabled="
                                            computedVariants.length === 0
                                        "
                                        :uk-tooltip="
                                            computedVariants.length === 0
                                                ? $t('variants.all.added')
                                                : ''
                                        "
                                        class="uk-select uk-input-styled">
                                        <option
                                            v-for="variant in computedVariants"
                                            :key="variant.id"
                                            :value="variant.id">
                                            {{
                                                variant.name +
                                                ': ' +
                                                $t('variant.' + variant.type) +
                                                ' (' +
                                                (variant.options
                                                    ? variant.options.length
                                                    : 0) +
                                                ' ' +
                                                (variant.options &&
                                                variant.options.length === 1
                                                    ? $t('option')
                                                    : $t('options')) +
                                                ')'
                                            }}
                                        </option>
                                    </select>
                                </div>

                                <div class="uk-width-auto">
                                    <span
                                        :uk-tooltip="
                                            selectedVariant === '' ||
                                            !this.selectedVariant
                                                ? $t('variants.no.selected')
                                                : $t('x.add', {
                                                      x: $t('variant'),
                                                  })
                                        ">
                                        <Button
                                            :is-disabled="
                                                computedVariants.length === 0 ||
                                                selectedVariant === '' ||
                                                !this.selectedVariant
                                            "
                                            is-max
                                            is-large
                                            mode="primary"
                                            has-action
                                            :action="addVariant">
                                            <Icon icon="plus" />
                                        </Button>
                                    </span>
                                </div>
                            </div>

                            <ul class="uk-list">
                                <li
                                    v-for="(
                                        selectedVariant, selectedVariantKey
                                    ) in selectedVariants"
                                    :key="selectedVariant.id">
                                    <span
                                        v-on:click="
                                            removeVariant(selectedVariantKey)
                                        ">
                                        <Icon
                                            :uk-tooltip="
                                                'title:' + $t('remove.variant')
                                            "
                                            icon="trash"
                                            class="uk-margin-small-right cursor-pointer" />
                                    </span>
                                    <span
                                        v-if="getVariantByID(selectedVariant)">
                                        {{
                                            getVariantByID(selectedVariant)
                                                .name +
                                            ': ' +
                                            $t(
                                                'variant.' +
                                                    getVariantByID(
                                                        selectedVariant
                                                    ).type
                                            ) +
                                            ' '
                                        }}
                                    </span>
                                    <span
                                        v-if="getVariantByID(selectedVariant)"
                                        :uk-tooltip="
                                            'title:' +
                                            joinedOptions(
                                                getVariantByID(selectedVariant)
                                                    .options
                                            )
                                        ">
                                        {{
                                            '(' +
                                            (getVariantByID(selectedVariant)
                                                .options
                                                ? getVariantByID(
                                                      selectedVariant
                                                  ).options.length
                                                : 0) +
                                            ' '
                                        }}
                                        <span
                                            v-if="
                                                getVariantByID(selectedVariant)
                                                    .options &&
                                                getVariantByID(selectedVariant)
                                                    .options.length === 1
                                            ">
                                            {{ $t('option') + ')' }}
                                        </span>
                                        <span v-else>
                                            {{ $t('options') + ')' }}
                                        </span>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="uk-grid uk-grid-divider uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-1"
                        uk-grid>
                        <div>
                            <LabelWithError
                                :error="clickAndBuyFileError"
                                :label="
                                    $t('link.files') +
                                    ' (' +
                                    $t('optional') +
                                    ')'
                                " />

                            <div class="uk-text-small uk-margin-small-bottom">
                                <Translate
                                    translation-key="link.files.description" />
                            </div>

                            <div class="uk-hidden" uk-form-custom>
                                <input
                                    :id="'clickandbuy-file' + this.id"
                                    :ref="'clickandbuyfile' + this.id"
                                    type="file"
                                    multiple
                                    v-on:change="fileHandleDrop()"
                                    v-on:click="
                                        $refs['clickandbuyfile' + id].value =
                                            null
                                    " />
                            </div>

                            <div
                                :id="'clickandbuy-file-upload' + this.id"
                                class="js-upload uk-placeholder uk-placeholder-hover uk-text-center cursor-pointer"
                                :class="{dragover: isDraggingFiles}"
                                @dragover.prevent="isDraggingFiles = true"
                                @dragleave="isDraggingFiles = false"
                                @drop.prevent="onDropFiles"
                                v-on:click="actionFileTriggerInput()">
                                <div>
                                    <Icon
                                        :ratio="2.2"
                                        class="upload-icon"
                                        icon="cloud-upload" />
                                </div>

                                <span class="uk-text-middle">{{
                                    $t('x.drop.or.', {
                                        x: $t('file'),
                                    })
                                }}</span>
                                <span class="uk-link uk-text-middle">{{
                                    $t('select')
                                }}</span>

                                <div
                                    v-if="clickAndBuyFileError"
                                    class="uk-margin-top" />
                                <LabelWithError
                                    v-if="clickAndBuyFileError"
                                    :error="clickAndBuyFileError"
                                    :label="$t('file')" />
                            </div>

                            <div
                                class="uk-grid-small uk-child-width-1-1"
                                uk-grid>
                                <div
                                    v-for="(
                                        articleFileId, key
                                    ) in newClickAndBuy.articleFileIds"
                                    :key="'articleFileId-' + key">
                                    <Card is-dark mode="default">
                                        <div class="uk-grid-small" uk-grid>
                                            <div class="uk-width-expand">
                                                <span
                                                    v-if="
                                                        isMarkDelete(
                                                            articleFileId
                                                        )
                                                    "
                                                    :uk-tooltip="
                                                        'title:' +
                                                        $t('expires.at')
                                                    ">
                                                    <div
                                                        class="file-name mark-delete">
                                                        {{
                                                            getRealFileName(
                                                                articleFileId
                                                            )
                                                        }}
                                                    </div>
                                                </span>
                                                <span
                                                    v-else-if="
                                                        isFile(articleFileId)
                                                    "
                                                    class="file-name mark-upload"
                                                    :uk-tooltip="
                                                        'title:' +
                                                        getRealFileName(
                                                            articleFileId
                                                        )
                                                    ">
                                                    {{
                                                        getRealFileName(
                                                            articleFileId
                                                        )
                                                    }}
                                                </span>
                                                <span
                                                    v-else
                                                    class="file-name"
                                                    :uk-tooltip="
                                                        'title:' +
                                                        getRealFileName(
                                                            articleFileId
                                                        )
                                                    ">
                                                    {{
                                                        getRealFileName(
                                                            articleFileId
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                            <div class="uk-width-auto">
                                                <span
                                                    v-if="
                                                        isFile(articleFileId)
                                                    ">
                                                    <Icon
                                                        :uk-tooltip="
                                                            'title:' +
                                                            $t('save.to.upload')
                                                        "
                                                        icon="cloud-upload" />
                                                </span>
                                                <span
                                                    v-else
                                                    class="cursor-pointer"
                                                    v-on:click="
                                                        actionArticleFileDownload(
                                                            articleFileId
                                                        )
                                                    ">
                                                    <Icon
                                                        :uk-tooltip="
                                                            'title:' +
                                                            $t('download')
                                                        "
                                                        icon="cloud-download" />
                                                </span>
                                            </div>
                                            <div class="uk-width-auto">
                                                <span
                                                    class="cursor-pointer"
                                                    v-on:click="
                                                        actionFileRecover(key)
                                                    "
                                                    v-if="
                                                        isMarkDelete(
                                                            articleFileId
                                                        )
                                                    ">
                                                    <Icon
                                                        :uk-tooltip="
                                                            'title:' +
                                                            $t('delete.cancel')
                                                        "
                                                        icon="history" />
                                                </span>
                                                <span
                                                    v-else
                                                    class="cursor-pointer"
                                                    v-on:click="
                                                        actionFileDelete(key)
                                                    ">
                                                    <Icon
                                                        :uk-tooltip="
                                                            'title:' +
                                                            $t('delete')
                                                        "
                                                        icon="trash" />
                                                </span>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                        <div>
                            <LabelWithError
                                :error="fileError"
                                :label="
                                    $t('attachment.files') +
                                    ' (' +
                                    $t('optional') +
                                    ')'
                                " />
                            <div class="uk-text-small uk-margin-small-bottom">
                                <Translate
                                    translation-key="attachment.files.description" />
                            </div>
                            <div class="uk-text-small">
                                <Translate
                                    translation-key="placeholder.variable.files.description" />

                                <div class="uk-margin-small-top">
                                    <Translate
                                        translation-key="placeholder.variable.files.description.pdf" />
                                </div>
                                <div
                                    class="uk-margin-small-top uk-margin-bottom uk-grid-small"
                                    uk-grid>
                                    <div
                                        v-for="placeholder in computedPlaceholders"
                                        :key="clickAndBuy.id + placeholder">
                                        <Button
                                            is-small
                                            with-class="cursor-pointer no-hover"
                                            mode="default">
                                            <Translate
                                                :translation-key="
                                                    placeholder
                                                " />
                                        </Button>
                                    </div>
                                </div>

                                <div class="uk-margin-top">
                                    <Translate
                                        translation-key="placeholder.variable.files.description.txt" />
                                </div>
                                <div
                                    class="uk-margin-small-top uk-margin-bottom uk-grid-small"
                                    uk-grid>
                                    <div
                                        v-for="placeholder in computedPlaceholders"
                                        :key="clickAndBuy.id + placeholder">
                                        <Button
                                            is-small
                                            with-class="cursor-pointer no-hover"
                                            mode="default">
                                            <Translate
                                                :translation-key="placeholder"
                                                prefix="{"
                                                suffix="}" />
                                        </Button>
                                    </div>
                                </div>
                            </div>

                            <div class="uk-hidden" uk-form-custom>
                                <input
                                    :id="'clickandbuy-filea' + this.id"
                                    :ref="'clickandbuyfilea' + this.id"
                                    type="file"
                                    multiple
                                    v-on:change="fileHandleDropAttach()"
                                    v-on:click="
                                        $refs['clickandbuyfilea' + id].value =
                                            null
                                    " />
                            </div>

                            <div
                                :id="'clickandbuy-file-uploada' + this.id"
                                class="js-upload uk-placeholder uk-placeholder-hover uk-text-center cursor-pointer"
                                :class="{dragover: isDraggingFiles}"
                                @dragover.prevent="isDraggingFiles = true"
                                @dragleave="isDraggingFiles = false"
                                @drop.prevent="onDropFilesAttach"
                                v-on:click="actionFileTriggerInputAttach()">
                                <div>
                                    <Icon
                                        :ratio="2.2"
                                        class="upload-icon"
                                        icon="cloud-upload" />
                                </div>

                                <span class="uk-text-middle">{{
                                    $t('x.drop.or.', {
                                        x: $t('file'),
                                    })
                                }}</span>
                                <span class="uk-link uk-text-middle">{{
                                    $t('select')
                                }}</span>

                                <div
                                    v-if="clickAndBuyFileErrora"
                                    class="uk-margin-top" />
                                <LabelWithError
                                    v-if="clickAndBuyFileErrora"
                                    :error="clickAndBuyFileErrora"
                                    :label="$t('file')" />
                            </div>

                            <div
                                class="uk-grid-small uk-child-width-1-1"
                                uk-grid>
                                <div
                                    v-for="(
                                        articleFileId, key
                                    ) in newClickAndBuy.attachedFileIds"
                                    :key="'attachFileId-' + key">
                                    <Card is-dark mode="default">
                                        <div class="uk-grid-small" uk-grid>
                                            <div class="uk-width-expand">
                                                <span
                                                    v-if="
                                                        isMarkDelete(
                                                            articleFileId
                                                        )
                                                    "
                                                    :uk-tooltip="
                                                        'title:' +
                                                        $t('expires.at')
                                                    ">
                                                    <div
                                                        class="file-name mark-delete">
                                                        {{
                                                            getRealFileName(
                                                                articleFileId
                                                            )
                                                        }}
                                                    </div>
                                                </span>
                                                <span
                                                    v-else-if="
                                                        isFile(articleFileId)
                                                    "
                                                    class="file-name mark-upload"
                                                    :uk-tooltip="
                                                        'title:' +
                                                        getRealFileName(
                                                            articleFileId
                                                        )
                                                    ">
                                                    {{
                                                        getRealFileName(
                                                            articleFileId
                                                        )
                                                    }}
                                                </span>
                                                <span
                                                    v-else
                                                    class="file-name"
                                                    :uk-tooltip="
                                                        'title:' +
                                                        getRealFileName(
                                                            articleFileId
                                                        )
                                                    ">
                                                    {{
                                                        getRealFileName(
                                                            articleFileId
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                            <div class="uk-width-auto">
                                                <span
                                                    v-if="
                                                        isFile(articleFileId)
                                                    ">
                                                    <Icon
                                                        :uk-tooltip="
                                                            'title:' +
                                                            $t('save.to.upload')
                                                        "
                                                        icon="cloud-upload" />
                                                </span>
                                                <span
                                                    v-else
                                                    class="cursor-pointer"
                                                    v-on:click="
                                                        actionAttachFileDownload(
                                                            articleFileId
                                                        )
                                                    ">
                                                    <Icon
                                                        :uk-tooltip="
                                                            'title:' +
                                                            $t('download')
                                                        "
                                                        icon="cloud-download" />
                                                </span>
                                            </div>
                                            <div class="uk-width-auto">
                                                <span
                                                    class="cursor-pointer"
                                                    v-on:click="
                                                        actionFileRecoverAttach(
                                                            key
                                                        )
                                                    "
                                                    v-if="
                                                        isMarkDelete(
                                                            articleFileId
                                                        )
                                                    ">
                                                    <Icon
                                                        :uk-tooltip="
                                                            'title:' +
                                                            $t('delete.cancel')
                                                        "
                                                        icon="history" />
                                                </span>
                                                <span
                                                    v-else
                                                    class="cursor-pointer"
                                                    v-on:click="
                                                        actionFileDeleteAttach(
                                                            key
                                                        )
                                                    ">
                                                    <Icon
                                                        :uk-tooltip="
                                                            'title:' +
                                                            $t('delete')
                                                        "
                                                        icon="trash" />
                                                </span>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>

            <div class="uk-margin-medium-bottom" />

            <div uk-grid>
                <div v-if="newClickAndBuy.id" class="uk-width-auto">
                    <div class="uk-button-group">
                        <div class="uk-inline">
                            <span
                                :uk-tooltip="
                                    'title:' + $t('x.delete', {x: $t(title)})
                                ">
                                <Button is-large is-max mode="danger">
                                    <Icon icon="trash" />
                                </Button>
                            </span>
                            <div
                                uk-dropdown="mode: click; target: !.uk-button-group;">
                                <ul class="uk-nav uk-dropdown-nav">
                                    <Translate
                                        translation-key="clickandbuy.delete.message" />
                                    <div class="uk-margin-small-top" />

                                    <Button
                                        :action="actionDelete"
                                        :is-loading="deleteLoading"
                                        has-action
                                        is-large
                                        is-max
                                        mode="danger">
                                        <Translate translation-key="delete" />
                                    </Button>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="uk-width-expand">
                    <Button
                        :action="actionDeclare"
                        :is-loading="loading"
                        :text="
                            $t(newClickAndBuy.id ? 'x.change' : 'x.add', {
                                x: $t(title),
                            })
                        "
                        has-action
                        is-large
                        is-max
                        mode="primary" />
                </div>
            </div>

            <div v-if="error" class="uk-margin-medium-bottom" />
            <ErrorMessage :error="error" />

            <div v-if="success" class="uk-margin-medium-bottom" />
            <SuccessMessage
                :success="success"
                :message="$t('x.changes.saved', {x: $t(title)})" />
        </span>
    </span>
</template>

<script>
import SuccessMessage from '@/components/generic/SuccessMessage.vue';
import Button from '@/components/generic/Button.vue';
import TextField from '@/components/generic/TextField.vue';
import ErrorMessage from '@/components/generic/ErrorMessage.vue';
import axios from 'axios';
import Icon from '@/components/generic/Icon.vue';
import LabelWithError from '@/components/generic/LabelWithError.vue';
import {VueEditor} from 'vue2-editor';
import CurrencyInput from '@/components/generic/CurrencyInput.vue';
import ClickAndBuyMediaForm from '@/views/clickandbuy/ClickAndBuyMediaForm.vue';
import SwitchButton from '@/components/generic/SwitchButton.vue';
import UIkit from 'uikit';
import VueCookie from 'vue-cookie';
import Translate from '@/components/Translate.vue';
import Vue from 'vue';
import Card from '@/components/generic/Card.vue';

export default {
    name: 'ClickAndBuyForm',
    components: {
        Card,
        Translate,
        SwitchButton,
        ClickAndBuyMediaForm,
        CurrencyInput,
        LabelWithError,
        Icon,
        ErrorMessage,
        TextField,
        Button,
        SuccessMessage,
        VueEditor,
    },
    props: {
        id: String,
        modalId: String,

        settings: Object,

        clickAndBuy: {
            id: String,

            title: String,
            text: String,

            emailText: String,
            mediaFileId: String,

            articleFileId: String,
            price: Number,

            disabled: Boolean,
            hidden: Boolean,
        },
        disabled: Boolean,

        variants: Array,
    },
    data() {
        return {
            trigger: 0,
            title: 'campaign',

            loading: false,
            success: false,
            error: null,

            validationTrigger: 0,

            newClickAndBuy: this.clickAndBuy,
            newMediaFileId: this.clickAndBuy.mediaFileId,

            clickAndBuyFile: this.clickAndBuy.articleFileId,
            clickAndBuyFileError: null,
            clickAndBuyFileErrora: null,

            isDraggingFiles: false,

            titleField: {
                value: this.clickAndBuy.title,
                valid: !!this.clickAndBuy.title,

                name: 'title',
                label: 'title',
                icon: 'hashtag',
                rules: 'required|max:64',
            },

            priceField: {
                value: this.clickAndBuy.price ?? 0.5,
                valid: true,

                name: 'price',
                label: 'price',
                icon: 'tag',
                rules: 'required',
                type: 'number',
                steps: 0.01,
            },

            shippingFeeField: {
                value: this.clickAndBuy.shippingFee ?? 0.0,
                valid: true,

                name: 'shippingFee',
                label: 'shippingFee',
                icon: 'cart',
                rules: 'required',
                type: 'number',
                steps: 0.01,
            },

            fileError: null,

            deleteError: null,
            deleteSuccess: false,
            deleteLoading: false,

            isActive: !this.clickAndBuy.disabled,
            isVisible: !this.clickAndBuy.hidden,
            withPrice: !!(this.clickAndBuy.price && this.clickAndBuy.price > 0),
            withVariablePrice: !!this.clickAndBuy.isPriceVariable,
            withShippingFee:
                this.clickAndBuy.shippingFee &&
                this.clickAndBuy.shippingFee > 0,

            selectedVariants: this.clickAndBuy.variantIds ?? [],
            selectedVariant: '',
            variantsCache: [],

            multipleOrderable: !!this.clickAndBuy.multipleOrderable,
            shippingCostsOnce: !!this.clickAndBuy.shippingCostsOnce,
        };
    },
    created() {
        if (!Array.isArray(this.newClickAndBuy.articleFileIds)) {
            this.newClickAndBuy.articleFileIds = [];
        }

        if (!Array.isArray(this.newClickAndBuy.attachedFileIds)) {
            this.newClickAndBuy.attachedFileIds = [];
        }
    },
    computed: {
        computedPlaceholders() {
            let placeholders = [
                'name',
                'emailAddress',
                'telephone',
                'street',
                'zip',
                'city',
                'country',
                'total',

                'title',
                'date',
                'totalInWords',
            ];

            if (this.newClickAndBuy.isPriceVariable) {
                placeholders.push('variablePrice');
            }

            if (this.newClickAndBuy.multipleOrderable) {
                placeholders.push('amount');
            }

            for (let i = 0; i < this.selectedVariants.length; i++) {
                const variant = this.getVariantByID(this.selectedVariants[i]);
                if (variant) placeholders.push(variant.name);
            }

            return placeholders;
        },
        computedVariants() {
            let variants = [];

            if (!this.variants) {
                return variants;
            }

            for (let i = 0, j = this.variants.length; i < j; i++) {
                const variant = this.variants[i];
                if (
                    this.selectedVariants &&
                    this.selectedVariants.includes(variant.id)
                ) {
                    continue;
                }

                variants.push(variant);
            }

            return variants;
        },
        computedPriceFieldLabel() {
            if (this.withVariablePrice) {
                return 'minimum.price';
            }

            return this.priceField.label;
        },
        computedCurrencyOptionsShipping() {
            return {
                currency: this.getInfos.currency,
                currencyDisplay: 'symbol',
                valueRange: {
                    min: 0.0,
                },
                precision: 2,
                hideCurrencySymbolOnFocus: false,
                hideGroupingSeparatorOnFocus: false,
                hideNegligibleDecimalDigitsOnFocus: false,
                autoDecimalDigits: false,
                useGrouping: true,
                accountingSign: false,
            };
        },
        computedCurrencyOptions() {
            return {
                currency: this.getInfos.currency,
                currencyDisplay: 'symbol',
                valueRange: {
                    min: 0.5,
                },
                precision: 2,
                hideCurrencySymbolOnFocus: false,
                hideGroupingSeparatorOnFocus: false,
                hideNegligibleDecimalDigitsOnFocus: false,
                autoDecimalDigits: false,
                useGrouping: true,
                accountingSign: false,
            };
        },
    },
    methods: {
        isMarkDelete(fileName) {
            if (this.isFile(fileName)) {
                return false;
            }

            return fileName.endsWith('_MARK_DELETE');
        },
        getRealFileName(fileName) {
            if (this.isFile(fileName)) {
                return fileName.name;
            }

            return fileName.replace(/_MARK_DELETE$/i, '');
        },
        isFile(object) {
            return object instanceof File;
        },
        fillPlaceholder(val) {
            const text = '{' + this.$t(val) + '}';

            const quill = this.$refs.editoremail.quill;

            const range = quill.getSelection(true);
            const index = range ? range.index : quill.getLength();

            quill.insertText(index, text);
            quill.setSelection(index + text.length);
        },
        handleSwitchMultipleOrderable(val) {
            this.success = false;

            if (val) {
                this.withVariablePrice = false;
            }
        },
        joinedOptions(options) {
            let joined = '';
            for (let i = 0, j = options.length; i < j; i++) {
                const option = options[i];

                if (i === 0) {
                    joined += option.name;
                } else if (i === j - 1) {
                    joined += ', ' + option.name;
                    //joined += ' ' + this.$t('and') + ' ' + option.name;
                } else {
                    joined += ', ' + option.name;
                }
            }
            return joined;
        },
        getVariantByID(id) {
            if (this.variantsCache[id]) {
                return this.variantsCache[id];
            }

            for (let i = 0, j = this.variants.length; i < j; i++) {
                const variant = this.variants[i];
                if (variant.id === id) {
                    this.variantsCache[id] = variant;
                    return variant;
                }
            }
        },
        removeVariant(key) {
            this.selectedVariants.splice(key, 1);
            this.$forceUpdate();
        },
        addVariant() {
            if (!this.selectedVariant || this.selectedVariant === '') {
                return;
            }

            this.selectedVariants.push(this.selectedVariant);
            this.selectedVariant = '';
        },
        setMediaFile(file) {
            this.newMediaFileId = file;
        },
        setValid(valid) {
            this.success = false;
            this.titleField.valid = valid;
        },
        actionFileTriggerInput() {
            document.getElementById('clickandbuy-file' + this.id).click();
        },
        actionArticleFileDownload(id) {
            event.preventDefault();

            let self = this;
            self.download = true;

            let request = new XMLHttpRequest();
            request.open(
                'GET',
                this.apiUrl +
                    '/manage-clickandbuys/' +
                    self.newClickAndBuy.id +
                    '/article/' +
                    id,
                true
            );
            request.responseType = 'blob';
            request.onload = function () {
                let blob = request.response;
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = self.getRealFileName(id);
                link.click();

                self.loadingDowload = false;
            };

            request.setRequestHeader('token', VueCookie.get('token'));
            request.send();
        },
        actionFileRecover(key) {
            const articleFile = this.newClickAndBuy.articleFileIds[key];

            Vue.set(
                this.newClickAndBuy.articleFileIds,
                key,
                articleFile.replace(/_MARK_DELETE$/i, '')
            );
        },
        actionFileDelete(key) {
            const articleFile = this.newClickAndBuy.articleFileIds[key];

            if (this.isFile(articleFile)) {
                this.newClickAndBuy.articleFileIds.splice(key, 1);
                return;
            }

            Vue.set(
                this.newClickAndBuy.articleFileIds,
                key,
                articleFile + '_MARK_DELETE'
            );
        },
        actionDelete() {
            this.deleteLoading = true;

            let http = axios.create();
            http.delete(
                this.apiUrl + '/manage-clickandbuys/' + this.newClickAndBuy.id
            )
                .then(() => {
                    this.deleteError = null;
                    this.deleteSuccess = true;
                    this.deleteLoading = false;

                    UIkit.modal('#' + this.modalId).hide();

                    if (this.clickAndBuy.id) {
                        this.$emit('declared', this.clickAndBuy.id);
                    }

                    UIkit.notification({
                        message: this.$t('clickandbuy.deleted.message'),
                        status: 'info',
                        pos: 'top-center',
                        timeout: this.notificationTimeout,
                    });
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.deleteError = e;
                    this.deleteSuccess = false;
                    this.deleteLoading = false;
                });
        },
        actionDeclare() {
            this.validationTrigger++;

            if (!this.titleField.valid) {
                return;
            }

            if (this.newClickAndBuy.id) {
                return this.actionUpdate();
            }

            return this.actionCreate();
        },
        onDropFiles(e) {
            this.isDraggingFiles = false;
            this.fileHandle(e.dataTransfer.files);
        },
        fileHandleDrop() {
            const files = this.$refs['clickandbuyfile' + this.id].files;
            this.fileHandle(files);
        },
        fileHandle(files) {
            for (const file of files) {
                if (
                    file.size >
                    this.settings.clickAndBuyInfos.articleFileSizeBytes
                ) {
                    this.clickAndBuyFileError = this.$t(
                        'name.can.be.maximum.size',
                        {
                            name: this.$t('link.files'),
                            size: this.getParsedBytes(
                                this.settings.clickAndBuyInfos
                                    .articleFileSizeBytes
                            ),
                        }
                    );
                    return;
                }

                const alreadyExists = this.newClickAndBuy.articleFileIds.some(
                    (item) => {
                        if (item instanceof File) {
                            return item.name === file.name;
                        }
                        return item === file.name;
                    }
                );

                if (alreadyExists) {
                    this.clickAndBuyFileError = this.$t(
                        'file.already.exists.blank',
                        {
                            name: file.name,
                        }
                    );
                    return;
                }
                this.clickAndBuyFileError = null;

                this.newClickAndBuy.articleFileIds.push(file);
                this.$forceUpdate();
            }
        },
        actionCreate() {
            this.loading = true;

            let price = null;
            let shippingFee = null;
            let variantIds = null;

            if (this.withPrice) {
                price = this.priceField.value;

                if (this.withShippingFee) {
                    shippingFee = this.shippingFeeField.value;
                }

                variantIds = this.selectedVariants;
            }

            let http = axios.create();
            http.post(this.apiUrl + '/manage-clickandbuys', {
                title: this.titleField.value,
                text: this.newClickAndBuy.text,

                emailText: this.newClickAndBuy.emailText,
                price: price,

                shippingFee: shippingFee,

                disabled: !this.isActive,
                hidden: !this.isVisible,

                isPriceVariable: this.withVariablePrice,

                variantIds: variantIds,

                multipleOrderable: this.multipleOrderable,
                shippingCostsOnce: this.shippingCostsOnce,
            })
                .then((response) => {
                    this.actionDeclareMediaFile(response.data.id);
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
        actionUpdate() {
            this.loading = true;

            let price = null;
            let shippingFee = null;
            let variantIds = null;

            if (this.withPrice) {
                price = this.priceField.value;

                if (this.withShippingFee) {
                    shippingFee = this.shippingFeeField.value;
                }

                variantIds = this.selectedVariants;
            }

            let http = axios.create();
            http.patch(
                this.apiUrl + '/manage-clickandbuys/' + this.newClickAndBuy.id,
                {
                    title: this.titleField.value,
                    text: this.newClickAndBuy.text,

                    emailText: this.newClickAndBuy.emailText,
                    price: price,

                    shippingFee: shippingFee,

                    disabled: !this.isActive,
                    hidden: !this.isVisible,

                    isPriceVariable: this.withVariablePrice,

                    variantIds: variantIds,

                    multipleOrderable: this.multipleOrderable,
                    shippingCostsOnce: this.shippingCostsOnce,
                }
            )
                .then(() => {
                    this.actionDeclareMediaFile();
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
        actionDeclareMediaFile(id) {
            let targetId = this.newClickAndBuy.id;
            if ((!targetId || targetId === 'new') && id) {
                targetId = id;
            }

            if (this.newMediaFileId && !this.newMediaFileId.name) {
                this.actionDeclareArticleFile();
                return;
            }

            let formData = new FormData();
            formData.append('mediaFile', this.newMediaFileId);

            this.loading = true;

            let http = axios.create();
            http.put(
                this.apiUrl +
                    '/manage-clickandbuys/' +
                    targetId +
                    '/media-file',
                formData
            )
                .then(() => {
                    this.actionDeclareArticleFile(targetId);
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
        async actionDeclareArticleFile(id) {
            let targetId = this.newClickAndBuy.id;
            if ((!targetId || targetId === 'new') && id) {
                targetId = id;
            }

            for (
                let i = 0, j = this.newClickAndBuy.articleFileIds.length;
                i < j;
                i++
            ) {
                const articleFileId = this.newClickAndBuy.articleFileIds[i];

                if (
                    !this.isFile(articleFileId) &&
                    !this.isMarkDelete(articleFileId)
                ) {
                    continue;
                }

                if (this.isMarkDelete(articleFileId)) {
                    await this.actionDeleteArticleFile(
                        targetId,
                        i,
                        articleFileId
                    );
                    continue;
                }

                this.actionPostArticleFile(targetId, i, articleFileId);
            }

            await this.actionDeclareAttachedFile();

            this.error = null;
            this.loading = false;
            UIkit.modal('#' + this.modalId).hide();
            this.$emit('declared', targetId);

            UIkit.notification({
                message: this.$t('clickandbuy.updated.message'),
                status: 'info',
                pos: 'top-center',
                timeout: this.notificationTimeout,
            });
        },
        async actionDeleteArticleFile(targetId, i, fileName) {
            let http = axios.create();
            http.delete(
                this.apiUrl +
                    '/manage-clickandbuys/' +
                    targetId +
                    '/article/' +
                    this.getRealFileName(fileName)
            )
                .then(() => {
                    this.newClickAndBuy.articleFileIds.splice(i, 1);

                    this.$emit('declared', targetId);
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
        actionPostArticleFile(targetId, i, file) {
            let formData = new FormData();
            formData.append('articleFile', file);

            this.loading = true;

            let http = axios.create();
            http.post(
                this.apiUrl + '/manage-clickandbuys/' + targetId + '/article',
                formData
            )
                .then(() => {
                    const articleFile = this.newClickAndBuy.articleFileIds[i];

                    Vue.set(
                        this.newClickAndBuy.articleFileIds,
                        i,
                        articleFile.name
                    );

                    this.$emit('declared', targetId);
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
        onDropFilesAttach(e) {
            this.isDraggingFiles = false;
            this.fileHandleAttach(e.dataTransfer.files);
        },
        fileHandleDropAttach() {
            const files = this.$refs['clickandbuyfilea' + this.id].files;
            this.fileHandleAttach(files);
        },
        fileHandleAttach(files) {
            for (const file of files) {
                if (
                    file.size >
                    this.settings.clickAndBuyInfos.attachedFileSizeBytes
                ) {
                    this.clickAndBuyFileErrora = this.$t(
                        'name.can.be.maximum.size',
                        {
                            name: this.$t('attachment.files'),
                            size: this.getParsedBytes(
                                this.settings.clickAndBuyInfos
                                    .attachedFileSizeBytes
                            ),
                        }
                    );
                    return;
                }

                const alreadyExists = this.newClickAndBuy.attachedFileIds.some(
                    (item) => {
                        if (item instanceof File) {
                            return item.name === file.name;
                        }
                        return item === file.name;
                    }
                );

                if (alreadyExists) {
                    this.clickAndBuyFileErrora = this.$t(
                        'file.already.exists.blank',
                        {
                            name: file.name,
                        }
                    );
                    return;
                }

                this.clickAndBuyFileErrora = null;

                this.newClickAndBuy.attachedFileIds.push(file);
                this.$forceUpdate();
            }
        },
        actionFileTriggerInputAttach() {
            document.getElementById('clickandbuy-filea' + this.id).click();
        },
        actionAttachFileDownload(id) {
            event.preventDefault();

            let self = this;
            self.download = true;

            let request = new XMLHttpRequest();
            request.open(
                'GET',
                this.apiUrl +
                    '/manage-clickandbuys/' +
                    self.newClickAndBuy.id +
                    '/attachments/' +
                    id,
                true
            );
            request.responseType = 'blob';
            request.onload = function () {
                let blob = request.response;
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = self.getRealFileName(id);
                link.click();

                self.loadingDowload = false;
            };

            request.setRequestHeader('token', VueCookie.get('token'));
            request.send();
        },
        actionFileRecoverAttach(key) {
            const articleFile = this.newClickAndBuy.attachedFileIds[key];

            Vue.set(
                this.newClickAndBuy.attachedFileIds,
                key,
                articleFile.replace(/_MARK_DELETE$/i, '')
            );
        },
        actionFileDeleteAttach(key) {
            const articleFile = this.newClickAndBuy.attachedFileIds[key];

            if (this.isFile(articleFile)) {
                this.newClickAndBuy.attachedFileIds.splice(key, 1);
                return;
            }

            Vue.set(
                this.newClickAndBuy.attachedFileIds,
                key,
                articleFile + '_MARK_DELETE'
            );
        },
        async actionDeclareAttachedFile(id) {
            let targetId = this.newClickAndBuy.id;
            if ((!targetId || targetId === 'new') && id) {
                targetId = id;
            }

            for (
                let i = 0, j = this.newClickAndBuy.attachedFileIds.length;
                i < j;
                i++
            ) {
                const articleFileId = this.newClickAndBuy.attachedFileIds[i];

                if (
                    !this.isFile(articleFileId) &&
                    !this.isMarkDelete(articleFileId)
                ) {
                    continue;
                }

                if (this.isMarkDelete(articleFileId)) {
                    await this.actionDeleteAttachedFile(
                        targetId,
                        i,
                        articleFileId
                    );
                    continue;
                }

                this.actionPostAttachedFile(targetId, i, articleFileId);
            }
        },
        async actionDeleteAttachedFile(targetId, i, fileName) {
            let http = axios.create();
            http.delete(
                this.apiUrl +
                    '/manage-clickandbuys/' +
                    targetId +
                    '/attachments/' +
                    this.getRealFileName(fileName)
            )
                .then(() => {
                    this.newClickAndBuy.attachedFileIds.splice(i, 1);

                    this.$emit('declared', targetId);
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
        actionPostAttachedFile(targetId, i, file) {
            let formData = new FormData();
            formData.append('articleFile', file);

            this.loading = true;

            let http = axios.create();
            http.post(
                this.apiUrl +
                    '/manage-clickandbuys/' +
                    targetId +
                    '/attachments',
                formData
            )
                .then(() => {
                    const articleFile = this.newClickAndBuy.attachedFileIds[i];

                    Vue.set(
                        this.newClickAndBuy.attachedFileIds,
                        i,
                        articleFile.name
                    );

                    this.$emit('declared', targetId);
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.child-description {
    font-size: 14px;
}

.file-name {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.mark-delete {
    text-decoration: line-through;
}

.mark-upload {
    opacity: 0.5;
}

.clickandbuy-file {
    max-width: 30px;
    max-height: 30px;
}

.clickandbuy-file-struct {
    width: 100%;
}
</style>
